import dayjs, { Dayjs } from 'dayjs';

export function secondsToDayjs(seconds: number): Dayjs {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Create a dayjs object with today's date but set the time to the duration
  return dayjs().hour(hours).minute(minutes).second(0).millisecond(0);
}

export function dayjsToSeconds(dayjsObj: Dayjs): number {
  const hours = dayjsObj.hour();
  const minutes = dayjsObj.minute();

  return hours * 3600 + minutes * 60;
}

// 'en' alone resolves to US order (month first) but the product shows English dates day first;
// 'df' (formal German) is not a real locale tag and would fall back to the browser's language.
const INTL_LOCALE_BY_APP_LANGUAGE: Record<string, string> = {
  en: 'en-GB',
  df: 'de-DE',
};

export function formatShortDate(timestamp: number, language: string): string {
  const locale = INTL_LOCALE_BY_APP_LANGUAGE[language] ?? language;

  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(timestamp);
}
